"use client";

import BaseIndicatorConfig from "../common/BaseIndicatorConfig";

export default function AlligatorConfig({
  indicator,
  onBack,
  onApply,
  isEditing,
}: {
  indicator: any;
  onBack: () => void;
  onApply: any;
  isEditing?: boolean;
}) {
  return (
    <BaseIndicatorConfig
      indicator={indicator}
      onBack={onBack}
      onApply={onApply}
      isEditing={isEditing}
      defaultExpandedStyle="jaw"
    />
  );
}
